import { useEffect, useState } from "react";
import Option from "../../../../Models/forms/Option";
import axiosApi from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (): Option[] => {
  const [recallStatusOptions, setRecallStatusOptions] = useState<Option[]>([]);

  useEffect(() => {
    axiosApi
      .get<{ name: string; id: number }[]>(
        `${BackendServices.REPORT_SERVICE.REPORT}/data/recallStatus`
      )
      .then(({ data }) => {
        setRecallStatusOptions(
          data
            .sort((a, b) => a.id - b.id)
            .map((option) => ({
              label: `${option.id} - ${option.name}`,
              value: option.id,
            }))
        );
      });
  }, []);
  return recallStatusOptions;
};
